module.exports = __webpack_public_path__ + "static/img/MItchell-Woods.3e8cf40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MItchell-Woods.jpg
// module id = DQ4a
// module chunks = 0